import {api} from './api';
import { UserProgress } from '../model/progress';

export const getUsersProgress = async (accessToken: string, programId: string): Promise<UserProgress[]> => {
    const response = await api.get<UserProgress[]>(`/programs/${programId}/progress/users`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    })

    return response.data as UserProgress[]
}